import { UploadOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { Button, Input, Upload } from 'antd';
import '@/pages/settings/style.css';

interface ListInputCSVProps {
    form: any
}

const createUploadFile = (file) => ({
    uid: '-1',
    name: file.name,
    originFileObj: file,
    status: 'done',
    url: URL.createObjectURL(file)
})

export const CommaListInputCSV = (props: ListInputCSVProps | any) => {

    const [input, setInput] = useState<any>()
    const [fileList, setFileList] = useState<any>()

    useEffect(() => {
        if (props.value && props.value.length !== 0) {
            let fileName = props.id + '.csv';
            let join = props.value || [];
            let originFileObj = new File([join], fileName, { type: `text/csv` });
            setInput(join);
            setFileList([createUploadFile(originFileObj)])
        }
    }, [props.value])

    useEffect(() => props.form.setFieldsValue({ [props.id]: input }), [input])

    const handleInput = (e) => {
        if (!e.currentTarget.value) {
            handleRemove()
        } else {
            let fileName = props.id + '.csv';
            let join = e.currentTarget.value;
            let originFileObj = new File([join], fileName, { type: `text/csv` });
            setFileList([createUploadFile(originFileObj)])
        }
        setInput(e.currentTarget.value);
    }

    const handleFile = (e) => {
        let reader = new FileReader();
        let uploaded = e.fileList[1] || e.fileList[0];
        if (uploaded && uploaded.status === 'uploading') {
            reader.onloadend = () => {
                setInput(reader.result?.toString());
                setFileList([createUploadFile(uploaded.originFileObj)])
            }
            reader.readAsText(uploaded.originFileObj)
        }
    }

    const handleRemove = () => setFileList([])

    return (
        <>
            <Input value={input} onChange={handleInput} />
            <Upload className="input-csv"
                multiple
                fileList={fileList}
                onChange={handleFile}
                onRemove={handleRemove}>
                <Button>
                    <UploadOutlined /> Upload
                </Button>
            </Upload>
        </>
    )
}